import "./landing-page-section.component.scss";

export default {
    template: require('./landing-page-section.component.html'),
    transclude: true,
    controller: function () {
        'ngInject';
    }
};
